export const CANCEL_UPLOAD = 'assessmentManager.cancelUpload';
export const cancelUpload = () => ({
  type: CANCEL_UPLOAD,
});

export const OPEN_UPLOAD_DIALOG = 'assessmentManager.openUploadDialog';
export const openUploadDialog = () => ({
  type: OPEN_UPLOAD_DIALOG,
});

export const CLOSE_UPLOAD_DIALOG = 'assessmentManager.closeUploadDialog';
export const closeUploadDialog = () => ({
  type: CLOSE_UPLOAD_DIALOG,
});

export const OPEN_CREATE_GROUP_DIALOG = 'assessmentManager.openCreateGroupDialog';
export const openCreateGroupDialog = () => ({
  type: OPEN_CREATE_GROUP_DIALOG,
});

export const CLOSE_CREATE_GROUP_DIALOG = 'assessmentManager.closeCreateGroupDialog';
export const closeCreateGroupDialog = () => ({
  type: CLOSE_CREATE_GROUP_DIALOG,
});

// Resets the transient status banner (success message / validation error). Dispatched on
// navigation away from the Assessment Manager and by the auto-dismiss timer so a stale
// "wrong file" warning doesn't linger across page changes.
export const CLEAR_STATUS = 'assessmentManager.clearStatus';
export const clearStatus = () => ({
  type: CLEAR_STATUS,
});

export default 'assessmentManager.actions.js';
